export default __webpack_public_path__ + "static/media/video.e7c8b371.svg";